import {Component} from "react";
import {Navigate} from "react-router-dom";
import { refreshAccessToken } from '../api/client';

class ProtectedRoute extends Component {
    state = {
        isAuth: null
    }

    componentDidMount() {
        const role = localStorage.getItem('role')
        if (role !== 'MANAGER' && role !== 'SUPERVISOR') {
            this.setState({isAuth: false})
            return
        }
        refreshAccessToken()
            .then((token) => {
                this.setState({isAuth: !!token})
            })
            .catch(() => {
                this.setState({isAuth: false})
            })
    }

    render() {
        return (
            <>
                {
                    this.state.isAuth === true ?
                        this.props.children
                    : this.state.isAuth === false ?
                        <Navigate to={'/'} replace={true}/>
                    :
                        null
                }
            </>
        );
    }
}
export default ProtectedRoute
